require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-health-savings-accounts-for-employees.json") })
        }
      }, "path---es-health-savings-accounts-for-employees");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-health-savings-accounts-for-employees!./.cache/json/es-health-savings-accounts-for-employees.json
// module id = 2569
// module chunks = 231608221292675